function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "prefix__a",
  d: "M0 0.268L98.732 0.268 98.732 99 0 99z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FF335D",
  d: "M97 49.5C97 75.733 75.733 97 49.5 97S2 75.733 2 49.5 23.267 2 49.5 2 97 23.267 97 49.5"
}), /*#__PURE__*/React.createElement("mask", {
  id: "prefix__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#1E1210",
  d: "M49.366 4.846c-24.697 0-44.788 20.091-44.788 44.788 0 24.696 20.091 44.788 44.788 44.788 24.696 0 44.788-20.092 44.788-44.788 0-24.697-20.092-44.788-44.788-44.788m0 94.154C22.146 99 0 76.855 0 49.634 0 22.414 22.145.268 49.366.268c27.22 0 49.366 22.145 49.366 49.366C98.732 76.854 76.586 99 49.366 99",
  mask: "url(#prefix__b)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1E1210",
  d: "M61.428 64.597c-3.473-1.486-7.953-2.149-11.475.679-3.56-2.747-7.985-2.374-11.381-1.206v-6.832c0-6.395 5.127-11.598 11.428-11.598 6.301 0 11.428 5.203 11.428 11.598v7.359zM50 82.36c-6.301 0-11.428-5.203-11.428-11.598V69.08c2.097-1.016 6.753-2.662 9.663.925l1.834 2.26 1.749-2.328c2.754-3.664 7.577-1.366 9.61-.145v.969c0 6.395-5.127 11.598-11.428 11.598zM50 41c-8.823 0-16 7.285-16 16.238v13.524C34 79.715 41.177 87 50 87c8.822 0 16-7.285 16-16.238V57.238C66 48.285 58.822 41 50 41zM38.135 37.337c.442.442 1.022.663 1.601.663.58 0 1.159-.221 1.601-.663.884-.884.884-2.318 0-3.202L38.202 31l3.135-3.135c.884-.884.884-2.318 0-3.202-.884-.883-2.317-.884-3.202 0L35 27.798l-3.135-3.135c-.884-.884-2.317-.884-3.202 0-.884.884-.884 2.318 0 3.202L31.799 31l-3.136 3.135c-.884.884-.884 2.318 0 3.202.442.442 1.022.663 1.601.663.58 0 1.159-.221 1.6-.663L35 34.202l3.135 3.135zM66.202 31l3.135-3.135c.884-.884.884-2.318 0-3.202-.884-.884-2.317-.884-3.202 0L63 27.8l-3.135-3.136c-.884-.884-2.317-.884-3.202 0-.884.884-.884 2.318 0 3.202L59.799 31l-3.136 3.135c-.884.884-.884 2.318 0 3.202.443.442 1.022.663 1.601.663.58 0 1.159-.22 1.601-.663L63 34.202l3.135 3.135c.442.442 1.021.663 1.6.663.58 0 1.16-.22 1.602-.663.884-.884.884-2.318 0-3.202L66.202 31z"
}));

var SvgEmojiError = function SvgEmojiError(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 99,
    viewBox: "0 0 99 99",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmojiError, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/emoji-error.612f731f.svg";
export { ForwardRef as ReactComponent };